import { useUnit } from 'effector-react'

import { Switch } from '@/components/ui/switch'
import { Tooltip } from '@/components/ui/tooltip.tsx'
import {
  $chatterLanguage,
  $isAutoTranslationsEnabled,
} from '@/models/chattingUI/messages/translations.ts'
import { useChats } from '@/modules/chatting/state/chats-provider'

export const LanguageSelector = () => {
  const isAutoTranslationsEnabled = useUnit($isAutoTranslationsEnabled)
  const chatterLanguage = useUnit($chatterLanguage)

  const { enableAutoTranslation, disableAutoTranslation } = useChats()

  const handleChangeSwitch = (checked: boolean) => {
    if (checked) {
      enableAutoTranslation()
    } else {
      disableAutoTranslation()
    }
  }

  return (
    <div className="flex items-center gap-1">
      <Tooltip
        content="If turned on, all messages from the fan will be translated automatically."
        asChild
      >
        <Switch
          isSmall
          checked={!!isAutoTranslationsEnabled}
          onCheckedChange={handleChangeSwitch}
          disabled={!chatterLanguage}
        />
      </Tooltip>
    </div>
  )
}
